module.exports = __webpack_public_path__ + "static/media/tick_icon.45a6cc58.svg";